import React from 'react'
import PropTypes from 'prop-types'
import { getNotificationContent } from './content'
import { relativeTimeParts } from './relativeTime'

const NotificationItem = ({ notification, onClick, t }) => {
  const { title, body } = getNotificationContent(notification, t)
  const time = relativeTimeParts(notification.createdAt)
  const rowClassName = 'NotificationCenter-Item'
    + (notification.read ? '' : ' NotificationCenter-Item--unread')

  return (
    <div
      className={rowClassName}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        // allow space and enter to trigger click on the item when tabbed on
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick && onClick(e)
        }
      }}
    >
      <span className={`NotificationCenter-Item-Dot NotificationCenter-Item-Dot--${notification.severity}`}/>
      <div className="NotificationCenter-Item-Message">
        {title && <p className="NotificationCenter-Item-Title">{title}</p>}
        {body && <p className="NotificationCenter-Item-Body">{body}</p>}
      </div>
      <span className="NotificationCenter-Item-Time">{t(time.key, time.options)}</span>
    </div>
  )
}

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    severity: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    createdAt: PropTypes.number.isRequired,
    payload: PropTypes.object,
  }).isRequired,
  onClick: PropTypes.func,
  t: PropTypes.func.isRequired,
}

export default NotificationItem
